<template>
  <!-- 到站数据 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">到站数据</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
        <el-input v-model="filterForm.id" type="number" placeholder="序号" clearable></el-input>
      </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.coalMineNo" clearable filterable placeholder="矿发名称">
            <el-option
              v-for="item in allCoalmineList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.carLicensePlateNo" placeholder="车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.mjpNo" placeholder="煤检票号" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="">
          <el-input v-model="filterForm.createTime" placeholder="导入时间" clearable></el-input>
        </el-form-item> -->
        <el-form-item label>
          <el-select v-model="filterForm.matchFlag" clearable placeholder="状态">
            <el-option
              v-for="item in matchStatusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.collectStationNo" clearable filterable placeholder="收货名称">
            <el-option
              v-for="item in stationList"
              :key="item.collectStationNo"
              :label="item.collectStationName"
              :value="item.collectStationNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.driverPhone" placeholder="手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.arriveStationPoundNo" placeholder="到站磅单号" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.createTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="导入开始时间"
            end-placeholder="导入结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.weighGrossTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="过毛开始时间"
            end-placeholder="过毛结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-sign-in"
            label="导入"
            perms="31210"
            @click="handleShowImportDialog"
            type="primary"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      v-loading="loading"
      :data="financeList"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="flowNo"
    >
      <el-table-column
        prop="id"
        width="80"
        align="center"
        fixed
        label="序号">
      </el-table-column>
      <el-table-column
        prop="coalMineName" 
        align="center" 
        label="矿发名称">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="collectStationName" 
        align="center" 
        label="收货名称">
      </el-table-column>
      <el-table-column
        prop="mjpNo"
        align="center"
        label="煤检票号">
      </el-table-column>
      <el-table-column
        prop="mjpDate"
        align="center"
        label="煤检票日期">
      </el-table-column>
      <el-table-column
        prop="carLicensePlateNo"
        align="center"
        label="车辆号">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="arriveStationPoundNo"
        align="center"
        label="到站磅单号">
      </el-table-column>
      <el-table-column
        prop="arriveStationTareWeight"
        align="center"
        label="到站皮重">
      </el-table-column>
      <el-table-column
        prop="arriveStationGrossWeight"
        align="center"
        label="到站毛重">
      </el-table-column>
      <el-table-column
        prop="arriveStationNetWeight"
        align="center"
        label="到站净重">
      </el-table-column>
      <el-table-column
        prop="mineSendTareWeight"
        align="center"
        label="矿发皮重">
      </el-table-column>
      <el-table-column
        prop="mineSendGrossWeight"
        align="center"
        label="矿发毛重">
      </el-table-column>
      <el-table-column
        prop="mineSendNetWeight"
        align="center"
        label="矿发净重">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="weighGrossTime"
        align="center"
        label="过毛时间">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="weighTareTime"
        align="center"
        label="过皮时间">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="createTime"
        align="center"
        label="导入时间">
      </el-table-column>
      <el-table-column
        prop="matchFlagDesc" 
        align="center" 
        label="状态"
        fixed="right">
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;padding: 10px;"
      ></el-pagination>
    </div>

    <!-- 上传弹窗 -->
    <!-- 退款弹窗 -->
    <el-dialog
      title="导入"
      :visible.sync="importDialogVisible"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="500px"
    >
      <div>
        <el-form
          :model="importForm"
          :rules="importRules"
          ref="importForm"
          label-width="100px"
          :size="size"
          class="importForm"
        >
          <el-form-item label="集运站名称" prop="collectStationNo">
            <el-select v-model="importForm.collectStationNo" placeholder="收货名称">
              <el-option
                v-for="item in stationList"
                :key="item.collectStationNo"
                :label="item.collectStationName"
                :value="item.collectStationNo"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入文件">
            <el-upload
              class="uploadExcel"
              ref="uploadExcel"
              action=""
              :limit="1"
              accept=".xlsx, .xls"
              :http-request="uploadOk"
              :before-upload="beforeUpload"
              :show-file-list="false">
              
                <kt-button
                  label="上传文件只支持 xls/xlsx 格式"
                  perms="-1"
                  type="primary"
                />
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="hanldeUploadExcel">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

let that = null;
export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      fullscreenLoading: false,
      searchLoading: false,
      financeList: [],
      allCoalmineList: [],
      stationList: [],
      matchStatusList: [
        {name: '已匹配', code : '1'},
        {name: '未匹配', code : '0'}
      ],
      filterForm: {},
      importDialogVisible: false,
      importForm: {},
      importRules: {
        collectStationNo: [{ required: true, message: "请选择集运站名称", trigger: "change" }]
      }

    };
  },
  created() {},
  mounted() {
    this.getArriveStationList();
    this.getAllCoalmineList();
    this.getAllStationList();
  },
  methods: {
    // 获取到站数据
    async getArriveStationList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "weighGrossTime" || key === "createTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = `${val[0]} 00:00:00`;
            params["searchFieldList[" + index + "].rangeMaxValue"] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.dataModel.mGetArriveStationData(params);
      const data = res.data;
      this.totalSize = data.totalSize || 0;
      if (data && data.dtoList && data.dtoList.length > 0) {
        this.financeList = data.dtoList;
      } else {
        this.financeList = [];
      }
      this.loading = false;
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getArriveStationList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getArriveStationList();
    },
    // 重置
    handleReset() {
      this.pageNo = 1;
      this.filterForm = {};
      this.handleSearch();
    },
    // 获取所有煤矿
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then(res => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },
    // 获取所有已启用的集运站
    async getAllStationList(){
      let params = {
        pageNo: 1,
        pageSize: 1000,
      }

      params['searchFieldList[0].fieldName'] = 'status';
      params['searchFieldList[0].singleValue'] = '0';
      let res = await this.$api.station.mGetStationList(params)
      if(res.data.dtoList){
        this.stationList = res.data.dtoList;
      } else {
        this.stationList = []
      }
      
    },
    // 展示导入弹窗
    handleShowImportDialog(){
      this.importDialogVisible = true
    },
    // 关闭弹窗
    dialogCloseCallback(){
      this.importForm = {}
    },

    // 上传前验证
    beforeUpload(file) {
      let Xls = file.name.split('.'); 
      if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
        return file
      }else {
        this.$message.error('上传文件只能是 xls/xlsx 格式!')
        return false
      }
    },
    // 上传成功
    async uploadOk(data){
      this.$refs['importForm'].validate(async (valid) => {
        console.log(valid)
        if (valid) {
          const formData = new FormData()
          let collectStationName = this.stationList.find(item => {
            return item.collectStationNo == this.importForm.collectStationNo
          }).collectStationName

          formData.append('file', data.file)
          formData.append('collectStationNo', this.importForm.collectStationNo)
          formData.append('collectStationName', collectStationName)
          
          try {
            await this.$api.dataModel.mImportArriveStationData(formData)
              // 拿到upload的dom
            this.$refs['importForm'].resetFields()
            this.$refs.uploadExcel.clearFiles()
            this.importDialogVisible = false
            this.$message({
              message: '上传成功',
              type: 'success'
            });
            this.getArriveStationList()
          } catch(err){
            this.$refs.uploadExcel.clearFiles()
          }
          
        } else {
          this.$refs.uploadExcel.clearFiles()
        }
      })
      
    }

  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

</style>
